import * as React from 'react'
import ReactHover, { Hover, Trigger } from 'react-hover'
import { CalendarHelper } from './calendar'
import { Element, RentList } from './warehouse_rent_list_types'
import { Moment } from 'moment'

interface RentListData extends RentList {
  quantity?: number
}

interface OverviewCalendarElementColumnsProps {
  element: Element
  startDate: string
  endDate: string
  rentListData: RentListData | null
}

function OverviewCalendarElementColumns({
  element,
  startDate,
  endDate,
  rentListData,
}: OverviewCalendarElementColumnsProps): React.ReactElement {
  const cal = new CalendarHelper(startDate, endDate)

  const cellColor = (day: Moment): string => {
    const NOT_RENTED = 'transparent'
    const RENTED = 'green'

    if (!rentListData) {
      return NOT_RENTED
    }

    // Check if day falls within this specific rent list period
    if (day.isBetween(rentListData.startDate, rentListData.endDate, 'day', '[]')) {
      return RENTED
    }

    return NOT_RENTED
  }

  const eventName = (day: Moment): string | null => {
    if (!rentListData) {
      return null
    }

    // Show information only if day falls within rental period
    if (day.isBetween(rentListData.startDate, rentListData.endDate, 'day', '[]')) {
      return `${rentListData.companyName || 'Unknown'} - ${rentListData.eventName || 'No event'} (${
        rentListData.quantity
      })`
    }

    return null
  }

  return (
    <>
      {cal.days().map((d) => {
        const color = cellColor(d)
        if (color === 'transparent') {
          return <td key={d.format('YY-MM-DD')} />
        }

        const event = eventName(d)
        const colorDataAttr = color === 'green' ? 'green' : color === 'lightcoral' ? 'lightcoral' : null

        if (!event) {
          return <td key={d.format('YY-MM-DD')} className="rent-list-table-calendar-cell" data-color={colorDataAttr} />
        }

        return (
          <td
            className="rent-list-table-hoverable-cell rent-list-table-calendar-cell"
            key={d.format('YY-MM-DD')}
            data-color={colorDataAttr}
          >
            <ReactHover options={{ followCursor: true, shiftX: 20, shiftY: 0 }}>
              <Trigger type="trigger">
                <div className="rent-list-table-hoverable-cell-trigger">&nbsp;</div>
              </Trigger>
              <Hover type="hover">
                <div className="rent-list-table-hoverable-cell-hover">{event}</div>
              </Hover>
            </ReactHover>
          </td>
        )
      })}
    </>
  )
}

export default OverviewCalendarElementColumns
